import React, { useState, useEffect, useRef } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, Overlay, Tooltip } from 'react-bootstrap';
import { getImageUrl } from '../../../configs/configs';
import CyberSecurity from '../../../apis/cyberSecurityData';
import { Editor } from '@tinymce/tinymce-react';

//imported comps
import CustomPopover from '../../common/CustomPopover/CustomPopover';

const options = {
    replace: ({ attribs, children }) => {
        if (!attribs) return;

        if (attribs.id === 'main') {
            return <h1 style={{ fontSize: 42 }}>{domToReact(children, options)}</h1>;
        }

        if (attribs.class === 'prettify') {
            return (
                <span style={{ color: 'hotpink' }}>
                    {domToReact(children, options)}
                </span>
            );
        }
    }
};

export default function ExistRelatedItem(props) {
    const { item, mainItem, fetchData } = props;
    console.log({ item, mainItem })
    //redux store state
    const accessToken = useSelector(state => state.accessToken);
    //comp local state
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [ttpDescription, setTtpDescription] = useState('');
    const [error, setError] = useState('');

    let title = '';
    if (item && item.title) title = item.title.substr(0, 50);

    useEffect(() => {
        if (item.ttpData && item.ttpData[0]) setTtpDescription(item.ttpData[0].ttpDescription);
    }, [])

    const onDeleteRelationClick = async () => {
        await CyberSecurity.delete('/relations', {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
            data: {
                item: { _id: item._id, mainCategory: item.mainCategory, newTag5: item.newTag5 },
                mainItem: { _id: mainItem._id, mainCategory: mainItem.mainCategory, newTag5: mainItem.newTag5 }
            }
        })
        props.onDeleteClick(item)
    }

    const onSaveClick = async () => {
        if (!ttpDescription) return setError('Please enter ttp description')
        setError('');

        const data = {
            breachId: mainItem._id,
            threatId: item._id,
            ttpDescription: ttpDescription
        }

        const response = await CyberSecurity.post('ttp/add', data, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        })

        console.log(response.data)
        if (fetchData) fetchData();
        setShow(false)
        // document.body.click();
    }

    const handleEditorChange = (e) => {
        // console.log(e.target)
        setTtpDescription(e.target.getContent());
    }

    return (
        <div className="main-item p-2 mb-2">
            <div className="d-flex">
                <div>
                    <p className='title pr-1 py-0 my-0'>{title}...</p>
                    {item.TTPNumber && <span className="py-1 px-2 my-1" style={{ background: '#3B5998', color: 'white', borderRadius: 5 }}>{item.TTPNumber}</span>}
                </div>
                <img className='item-image-small ml-auto' src={getImageUrl(item.image)} alt="item" />
            </div>

            {item.ttpData && item.ttpData[0] && <div className="mb-2" >
                <hr className="p-0 m-0 my-2" />
                {/* <p className="p-0 m-0  text-highliten">TTP Info</p> */}
                {parse(item.ttpData[0].ttpDescription)}
                {/* <span className="text-xs">{item.ttpData[0].ttpDescription}</span> */}
            </div>}

            <div className="d-flex">
                <Button variant="outline-danger" size="sm" onClick={onDeleteRelationClick}>Delete Relation</Button>

                {item.mainCategory === 'Threats' && mainItem.newTag5.includes('Breach') &&
                    <>
                        <Button className="ml-auto" variant="outline-secondary" size="sm" ref={target} onClick={() => setShow(!show)}>Info</Button>
                        <Overlay target={target.current} show={show} placement="right">
                            {(props) => (
                                <Tooltip id="overlay-example" {...props}>
                                    <div>
                                        <Editor
                                            apiKey="y2og6xgjnchnapn8fzkpiihtlqpqkm3mgu2dw2a9guz4ysxm" cloudChannel='stable'
                                            initialValue={`<p>${ttpDescription}</p>`}
                                            init={{
                                                selector: "textarea",
                                                plugins: [
                                                    'textcolor', 'colorpicker'
                                                ],
                                                toolbar: [
                                                    'undo redo | bold italic underline',
                                                    'forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist outdent indent'
                                                ],
                                                color_map: [
                                                    '2DC26B', 'Green',
                                                    'F1C40F', 'Yellow',
                                                    'E03E2D', 'Red',
                                                    'EA5454', 'Threats',
                                                    '3598DB', 'Blue'
                                                ],
                                                custom_colors: true,
                                                // custom_colors: [
                                                //     "#E14D43", "Color 1 Name",
                                                //     "#D83131", "Color 2 Name",
                                                //     // "ED1C24", "Color 3 Name",
                                                //     // "F99B1C", "Color 4 Name",
                                                //     // "50B848", "Color 5 Name",
                                                //     // "00A859", "Color 6 Name",
                                                //     // "00AAE7", "Color 7 Name",
                                                //     // "282828", "Color 8 Name"
                                                // ]

                                            }}

                                            onChange={handleEditorChange}
                                        />
                                        {/* <Form.Control as="textarea" type="textarea" placeholder="Add TTP Description" style={{ height: 100, width: 400 }} value={ttpDescription} onChange={(e) => setTtpDescription(e.target.value)} /> */}
                                        <Button className="mt-2 mr-2" variant="secondary" size="sm" onClick={() => setShow(false)}>Cancel</Button>
                                        <Button className="mt-2" variant="primary" size="sm" onClick={onSaveClick}>Save</Button>
                                        {error && <p style={{ color: 'red' }}>{error}</p>}
                                    </div>

                                </Tooltip>
                            )}
                        </Overlay>
                    </>
                }

            </div>
        </div >
    )
}